import { render } from "./schools-district.vue?vue&type=template&id=75da8c04"
import script from "./schools-district.js?vue&type=script&lang=js"
export * from "./schools-district.js?vue&type=script&lang=js"

import "./schools-district.vue?vue&type=style&index=0&id=75da8c04&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__